var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

var BtTermsNotice = function BtTermsNotice(props) {
  var goBack = props.goBack;
  return __jsx(Container, null, __jsx(Row, null, __jsx(Col, {
    className: "p-3"
  }, __jsx("p", null, "Datele tale completate in campurile de mai sus vor fi utilizate de Banca Transilvania in vederea contactarii tale pentru prezentarea conditiilor aferente produsului de creditare BT ales de tine. Detalii despre modul in care Banca Transilvania prelucreaza datele cu caracter personal regasesti in ", __jsx(Link, {
    href: "https://www.bancatransilvania.ro/politica-prelucrare-si-protectie-date-personale/"
  }, __jsx("a", {
    target: "_blank"
  }, "Politica de confidentialitate BT")), " ."), __jsx("p", null, "Apasand butonul \u201CTrimite\u201D, intelegi ca aceasta solicitare nu reprezinta o cerere de credit."), __jsx(Button, {
    variant: "outline-secondary",
    onClick: goBack
  }, __jsx(FontAwesomeIcon, {
    icon: faChevronLeft,
    height: "16",
    width: "16",
    className: "mr-2"
  }), "\xCEnapoi"))));
};

export default BtTermsNotice;